"use client";

import * as React from "react";
import {
  ArrowUpDown,
  ChartCandlestick,
  Coins,
  Gem,
  LifeBuoy,
  Settings,
  Wallet,
} from "lucide-react";
import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import Link from "next/link";

const data = {
  user: {
    name: "sajadevo",
    address: "0x6f8f...123456",
    avatar: "/avatars/sajadevo.png",
  },
  navMain: [
    {
      title: "Portfolio",
      url: "/portfolio",
      icon: Wallet,
    },
    {
      title: "Market",
      url: "/market",
      icon: ChartCandlestick,
    },
    {
      title: "Transactions",
      url: "/transactions",
      icon: ArrowUpDown,
    },
    {
      title: "Rewards",
      url: "/rewards",
      icon: Gem,
    },
    {
      title: "Staking",
      url: "/staking",
      icon: Coins,
    },
    {
      title: "Settings",
      url: "/settings",
      icon: Settings,
    },
    {
      title: "Supports",
      url: "#",
      icon: LifeBuoy,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" className="group/menu-button" asChild>
              <Link href="/">
                <div className="bg-primary text-primary-foreground flex aspect-square size-9 items-center justify-center gap-2.5 rounded-lg text-lg font-extrabold">
                  C
                </div>
                <div className="grid flex-1 gap-0.5 text-left text-sm leading-tight">
                  <span className="truncate font-medium">Crypto Inc</span>
                  <span className="text-foreground truncate text-xs font-normal group-hover/menu-button:text-inherit">
                    Crypto Analytics
                  </span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent className="mt-6 p-1">
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter>
    </Sidebar>
  );
}
